import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { TbPokerChip } from "react-icons/tb";
import "react-circular-progressbar/dist/styles.css";
import { IoLogoGameControllerA } from "react-icons/io";
import { VipList } from "./vipList";
import { Route, useNavigate } from "react-router";
import PromotionCard from "./components/promotionCard";
import ProgressCard from "./components/progressCard";
import MainCard from "./components/mainCard";
import DetailWrapper from "../../components/detailWrapper";
import LazyImage from "../../components/Loading/lazyImage";
import { common_route } from "../../utils/routes";
import VipListCard from "./components/vipList";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useMemo } from "react";
import { vipPromotion } from "./helper/detailList";
import useVipInfo from "../../hook/useVipInfo";
import VipPromotionList from "./components/vipPromotionList";

const SimpleVip = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`vip.${key}`, { ...props });

  const vipInfo = useVipInfo();
  const vipList = useSelector((state) => state.isVipDetail);

  const { nowLevel, nowWash } = vipInfo;

  const navigate = useNavigate();

  return (
    <DetailWrapper>
      <CloseDetailPage title={i18n("title")} />
      <article className="mt-[20px] flex flex-col gap-[20px]">
        <section className="flex items-center justify-between px-[5px]">
          <span className="text-transaction-card-text dark:text-base-light-white font-medium text-2xl">
            {i18n("myLevel")}
          </span>
          {/* <span className="py-[1px] px-[10px] rounded-full bg-base-light-white dark:bg-base-light-dark text-sm text-dark-gray-text dark:text-base-light-white font-semibold tracking-tighter">
            {i18n("leftDays", { day: 30 })}
          </span> */}
        </section>

        <MainCard nowWash={nowWash} nowLevel={nowLevel} />
        <section>
          <span className="text-transaction-card-text dark:text-base-light-white font-medium text-2xl">
            {i18n("nextLevel")}
          </span>
        </section>

        <section className="bg-transaction-card dark:bg-base-light-dark p-[8px] rounded-[5px] flex flex-col gap-[10px]">
          <ProgressCard nowWash={nowWash} nowLevel={nowLevel} />
          <VipPromotionList customLevel={nowLevel + 1} />
        </section>

        <VipListCard />
      </article>
    </DetailWrapper>
  );
};

export default SimpleVip;
